import Typography from "ds/components/Typography";

import ChangeHistoryCardSeparator from "./Separator";
import ChangeHistoryCardTimeLabel from "./TimeLabel";
import ChangeHistoryCardVersionBadges from "./VersionBadges";

type ChangeHistoryCardVersionAndInputsSummaryProps = {
  from: string;
  to: string;
  inputCount: number;
  timeLabel: string;
};

const ChangeHistoryCardVersionAndInputsSummary = ({
  from,
  to,
  inputCount,
  timeLabel,
}: ChangeHistoryCardVersionAndInputsSummaryProps) => (
  <>
    <ChangeHistoryCardVersionBadges from={from} to={to} />
    <Typography tag="span" variant="p-body3" color="secondary">
      and
    </Typography>
    <Typography tag="span" variant="p-t7">
      {inputCount}
    </Typography>
    <Typography tag="span" variant="p-body3" color="secondary">
      inputs
    </Typography>
    <ChangeHistoryCardSeparator />
    <ChangeHistoryCardTimeLabel timeLabel={timeLabel} />
  </>
);

export default ChangeHistoryCardVersionAndInputsSummary;
